import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';
import { DetailBox } from '@octano/global-ui';
import { format } from 'rut.js';
import { Postulant } from '../types';
import { PathsLayouts } from '../../../../../../config/routes';
import GoBackToListButton from '../../../../../../components/Button/GoBackToListButton';

interface HeaderProps {
  postulant: Postulant;
}

export default function Header({ postulant }: HeaderProps) {
  const { t } = useTranslation();
  return (
    <Row className="d-flex justify-content-between align-items-center mt-4">
      <Col xs={12} md={6} lg={3}>
        <GoBackToListButton path={PathsLayouts.studentFile} />
      </Col>
      <Col xs={12} md={6} lg={5}>
        <DetailBox
          columns={[
            {
              title: t('terms:student.single'),
              body: postulant.fullName,
              size: { xs: 12, md: 8 },
            },
            {
              title: 'ID',
              body: format(postulant.rut, { dots: true }),
              size: { xs: 12, md: 4 },
            },
          ]}
        />
      </Col>
    </Row>
  );
}
